<template>
  <div class="home">
  	<!-- <Tabbar msg="/" /> -->
    <Header msg="/" />
    <indexPage />
    <Foot />
  </div>

</template>

<script>
// @ is an alias to /src
import indexPage from '@/components/HelloWorld.vue'
import Tabbar from '@/components/tabbar.vue'
import Header from '@/components/header.vue'
import Foot from '@/components/foot.vue'
export default {
  name: 'home',
  components: {
      indexPage,
      Tabbar,
      Header,
      Foot
  },
  data:()=>{
  	return{
  		message:"",
  	}
  	
  },
  beforeCreate:function(){
    // console.log("获取手机")
	// var device_type = navigator.userAgent;//获取userAgent信息
	// console.log("userAgent信息",device_type)
	// console.log(this.message)
	
	// var md = new MobileDetect(device_type);//初始化mobile-detect
	// var os = md.os();//获取系统
	// var model = "";
	// document.write(md)

	// if (os == "iOS") {//ios系统的处理
	// 	os = md.os() + md.version("iPhone");
	// 	model = md.mobile();
	// } else if (os == "AndroidOS") {//Android系统的处理
	// 	os = md.os() + md.version("Android");
	// 	var sss = device_type.split(";");
	// 	var i = sss.contains("Build/");
	// 	if (i > -1) {
	// 		model = sss[i].substring(0, sss[i].indexOf("Build/"));
	// 	}
	// }
	// alert(os + "---" + model);//打印系统版本和手机型号

  },
  created:function () {
  	console.log("获取手机")
  	 
	var device_type = navigator.userAgent;//获取userAgent信息
	console.log("userAgent信息",device_type)
	// let os="电脑"
	// if(new MobileDetect()){
	// 	os = new MobileDetect(device_type).os()
	// }
 //  console.log(os)
  	// this.message =os
  
   
  },
 beforeRouteEnter(to, from, next) {
    // console.log(this, 'beforeRouteEnter'); // undefined
    // console.log(to, '组件独享守卫beforeRouteEnter第一个参数');
    // console.log(from, '组件独享守卫beforeRouteEnter第二个参数');
    // console.log(next, '组件独享守卫beforeRouteEnter第三个参数');
    next(vm => {
      //因为当钩子执行前，组件实例还没被创建
      // vm 就是当前组件的实例相当于上面的 this，所以在 next 方法里你就可以把 vm 当 this 来用了。
      console.log(vm);//当前组件的实例
      vm.message ="你好"
    });
  },
  beforeRouteUpdate(to, from, next) {
    //在当前路由改变，但是该组件被复用时调用
    //对于一个带有动态参数的路径 /good/:id，在 /good/1 和 /good/2 之间跳转的时候，
    // 由于会渲染同样的good组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
    // 可以访问组件实例 `this`
    // console.log(this, 'beforeRouteUpdate'); //当前组件实例
    // console.log(to, '组件独享守卫beforeRouteUpdate第一个参数');
    // console.log(from, '组件独享守beforeRouteUpdate卫第二个参数');
    // console.log(next, '组件独享守beforeRouteUpdate卫第三个参数');
    next();
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    // console.log(this, 'beforeRouteLeave'); //当前组件实例
    // console.log(to, '组件独享守卫beforeRouteLeave第一个参数');
    // console.log(from, '组件独享守卫beforeRouteLeave第二个参数');
    // console.log(next, '组件独享守卫beforeRouteLeave第三个参数');
    next();
  },
  methods:{

  }
}
</script>
